import type { RouteLocationNormalized } from "vue-router";
import i18n from "@/app/plugins/i18n";
import { useSnackBarStore } from "@/shared/stores/snackbar";

// Trusted build configuration only. Never use account data or an incoming URL as a destination.
const BETA_ORIGINS = new Map([
  ["dev-hiveway-pos", "https://beta.nectarpay.dev"],
  ["prod-hiveway-pos", "https://beta.nectarpay.app"],
  ["demos-hiveway-pos", "https://beta.demo.nectarpay.dev"],
  ["stage-hiveway-pos", "https://beta.stage.nectarpay.app"],
]);

export function isMerchantSessionRoute(route: RouteLocationNormalized): boolean {
  if (route.matched.some((record) => record.meta.skipMerchantGuards)) {
    return false;
  }
  return (
    route.matched.some((record) => record.meta.requiresAuth) ||
    ["login", "register", "invite", "resetpassword", "resetPassword"].includes(String(route.name))
  );
}

/** True means stop old-app routing, including when destination configuration is missing. */
export function redirectMigratedAccount(account: { migratedToBeta?: boolean } | null): boolean {
  if (account?.migratedToBeta !== true) {
    return false;
  }
  const origin = BETA_ORIGINS.get(import.meta.env.VITE_PROJECT_ID || "");
  if (!origin) {
    useSnackBarStore().toastError({ message: i18n.global.t("migration.destinationUnavailable") });
    return true;
  }
  window.location.replace(`${origin}/sign-in?migrated=1`);
  return true;
}
